var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-new-order"},[_c('form-customer',{attrs:{"title":_vm.$gettext('Add Customer')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }